import { logout } from "../app/features/userSlice"

export const handleAPIError = (error, { dispatch, navigate, openErrorSnackbar }, isHome = false) => {
  if (error.response.status === 401) {
    dispatch(logout())
    return
  }
  if (error.response.status === 403) {
    const planStatus = error?.response?.data?.status
    if (planStatus === "not_subscribed") {
      navigate("/plan")
      return
    }

    navigate("/unpaid")
    return
  }

  if (error.response.status === 423) {
    navigate("/collect-tax-id")
    return
  }

  if (!isHome) {
    navigate("/")
    return
  }

  openErrorSnackbar("Ocorreu um erro inesperado")
  return
}